import React from 'react';

const getRequiredCsvColumns = (listType: SingleListType | null, merchantSpecific: boolean): ImporterColumn[] => {
    const merchantIdColumn = {
        acceptableHeaders: ['identifier'],
        accessor: 'merchantId'
    };

    const commentColumn = {
        acceptableHeaders: ['comment'],
        accessor: 'comment'
    };

    const generalListValueColumn = {
        acceptableHeaders: ['value'],
        accessor: 'value'
    };

    const panListValueColumn = {
        acceptableHeaders: ['primary account number'],
        isTokenField: true,
        accessor: 'value'
    };

    const actionColumn = {
        acceptableHeaders: ['action'],
        accessor: 'action',
        valuesToCount: ['remove']
    };

    let columns: ImporterColumn[];

    switch (listType) {
        case 'GENERAL': {
            columns = [commentColumn, generalListValueColumn, actionColumn];
            break;
        }

        case 'PAN': {
            columns = [commentColumn, panListValueColumn, actionColumn];
            break;
        }
        // 'Unsupported List Type'
        default:
            return [];
    }
    return merchantSpecific ? columns.concat(merchantIdColumn) : columns;
};

const useGetImporterRequiredColumns = (listType: SingleListType | null, merchantSpecific: boolean) => {
    const columns = React.useMemo(() => {
        return getRequiredCsvColumns(listType, merchantSpecific);
    }, [listType, merchantSpecific]);

    return columns;
};

export default useGetImporterRequiredColumns;
